export function falhaNaoMapeadaHandler(error) {
    if (error.response) {
        if (error.response.status === 400 || error.response.status === 401 || error.response.status === 403 || error.response.status === 404) {
            return false;
        } else {
            return true;
        }
    }
    return true;
}
